module.exports = __webpack_public_path__ + "img/img-6.5f07eaa6.jpg";